<template>
  <!-- <div> -->
  <!--  -->
  <header class="navbar-fixed-top">
    <nav class="navbar navbar-default header_top panel-group" id="nav_groups">
      <!-- top -->
      <div class="login-wrapper pc" v-if="global.config[global.area_id]['isuser']">
        <div class="login">
          <div class="login-left">
            <p>您好，欢迎来到 MPD 技术管理工作坊</p>
            <div class="login-button" v-if="!logined">
              <a @click="login">登录</a>
              <div>/</div>
              <a class="register" @click="register">注册</a>
            </div>
            <slot v-else>
              <span>{{ userName }}</span>
            </slot>
          </div>
          <div class="login-right" v-if="logined">
            <!-- <a @click="openVip" v-if="!isv">成为会员</a> -->
            <a @click="goUserCenter()">用户中心</a>
            <a @click="quit">退出</a>
          </div>
        </div>
      </div>
      <!-- list: has user -->
      <div class="container-fluid panel panel-default" v-if="global.config[global.area_id]['isuser']">
        <div class="navbar-header panel-heading isuser">
          <!-- user mob -->
          <button
            type="button"
            class="navbar-toggle collapsed"
            id="bs-example-navbar-header-2"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-2"
            aria-expanded="false"
            aria-controls="bs-example-navbar-collapse-2"
            style="padding-top:5px;padding-bottom:5px;"
          >
            <img src="https://f.msup.com.cn/login-user-icon.png" class="user-icon" style="height:22px;margin-top:0;">
            <!-- <span class="icon-bar"></span> -->
          </button>
          <!-- logo -->
          <a @click.prevent="refreshH('home')" class="turn_link"><img src="@/assets/logo.png"/></a>
          <!-- list btn mob -->
          <button
            type="button"
            class="navbar-toggle collapsed"
            id="bs-example-navbar-header-1"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
            aria-controls="bs-example-navbar-collapse-1"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse panel-collapse" id="bs-example-navbar-collapse-1" data-parent="#nav_groups" aria-labelledby="bs-example-navbar-header-1">
          <ul class="nav navbar-nav">
            <li>
              <!-- <router-link class="turn_link turn_linkshouye" :to="{path:'/home',query:{sid:this.sid}}">首页</router-link> -->
              <!-- <a href="/home" class="turn_link turn_linkshouye">首页</a> -->
              <a @click.prevent="refreshH('home')" class="turn_link">首页</a>
            </li>
            <li v-if="global.config[global.area_id]['isuser'] && global.config[global.area_id]['haslive']">
              <a @click.prevent="refreshH('live_schedule')" class="turn_link">{{global.config[global.area_id]['livevod']?'大会回放':'大会直播'}}</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/schedule',query:{sid:this.sid}}">日程安排</router-link> -->
              <!-- <a href="/schedule" class="turn_link">日程安排</a> -->
              <a @click.prevent="refreshH('schedule')" class="turn_link">日程安排</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/experts',query:{sid:this.sid}}">演讲嘉宾</router-link> -->
              <!-- <a href="/experts" class="turn_link">演讲嘉宾</a> -->
              <a @click.prevent="refreshH('experts')" class="turn_link">演讲嘉宾</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/about',query:{sid:this.sid}}">关于</router-link> -->
              <!-- <a href="/about" class="turn_link">关于</a> -->
              <a @click.prevent="refreshH('about')" class="turn_link">关于</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/review',query:{sid:this.sid}}">往期回顾</router-link> -->
              <!-- <a href="/review" class="turn_link">往期回顾</a> -->
              <a @click.prevent="refreshH('review')" class="turn_link">往期回顾</a>
            </li>
            <li>
              <!-- <a v-if="sid==2690||sid==2691||sid=='2690'||sid=='2691'" @click.prevent="refreshH('collect')" class="turn_link">案例征集</a> -->
              <!-- <a v-if="sid==2690||sid==2691||sid=='2690'||sid=='2691'" :href="shref" target="_blank" class="turn_link">案例征集</a> -->
              <a v-if="sid==2690||sid==2691||sid=='2690'||sid=='2691'" @click.prevent="refreshH('col')" target="_blank" class="turn_link">案例征集</a>
            </li>
            <div class="mob">
              <div class="dibiao">
                <span class="glyphicon glyphicon-time"></span>
                <span class="wenz zd_time">{{meeting.time}}</span>
                <span class="wenz didian" style="float: right;" v-if="meeting.address.indexOf('直播')!=-1">{{meeting.address}}</span>
                <span class="wenz didian" style="float: right;" v-else>中国.{{global.config[sid].title}}</span>
                <span class="glyphicon glyphicon-map-marker" style="float: right;" ></span>
              </div>
              <div class="buy_btn">
                <a @click.prevent="refreshH('order')" class="turn_link_order wap_discount reallink">团队报名最低6折优惠！</a>
              </div>
            </div>
          </ul>
          <div class="buy_btn pc" v-if="global.area_id && global.config[global.area_id]">
            <!-- <router-link class="turn_link_order turn_link reallink" :to="{path:'/order',query:{sid:this.sid}}">立即购票</router-link> -->
            <!-- <a href="/order" class="turn_link_order turn_link reallink">立即购票</a> -->
            <a @click.prevent="refreshH('order')" class="turn_link" v-if="global.year.includes(thisYear)">立即购票</a>
            <a class="turn_link" v-else>已售罄</a>
          </div>
          <div class="buy_btn pc" v-else>
            <a class="turn_link">敬请期待</a>
          </div>
        </div>
        <div class="collapse navbar-collapse panel-collapse" id="bs-example-navbar-collapse-2" data-parent="#nav_groups" aria-labelledby="bs-example-navbar-header-2" v-if="global.config[global.area_id]['isuser']" style="overflow-y: hidden;">
          <ul class="nav navbar-nav" v-if="!logined">
            <li>
              <a @click.prevent="login()" class="turn_link">登录</a>
            </li>
          </ul>
          <ul class="nav navbar-nav" v-else>
            <li>
              <a @click.prevent="goUserCenter(0)" class="turn_link">我的门票</a>
              <a @click.prevent="goUserCenter(1)" class="turn_link">我的订单</a>
              <a @click.prevent="goUserCenter(2)" class="turn_link">个人设置</a>
              <a @click.prevent="quit" class="turn_link">退出</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- list: no user -->
      <div class="container-fluid" v-else>
        <div class="navbar-header">
          <!-- list btn mob -->
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-0"
            aria-expanded="false"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <!-- logo -->
          <!-- <router-link class="turn_link" :to="{path:'/home',query:{sid:this.sid}}"><img src="@/assets/logo.png"/></router-link> -->
          <!-- <a href="/home" class="turn_link"><img src="@/assets/logo.png"/></a> -->
          <a @click.prevent="refreshH('home')" class="turn_link"><img src="@/assets/logo.png"/></a>
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-0">
          <ul class="nav navbar-nav">
            <li>
              <!-- <router-link class="turn_link turn_linkshouye" :to="{path:'/home',query:{sid:this.sid}}">首页</router-link> -->
              <!-- <a href="/home" class="turn_link turn_linkshouye">首页</a> -->
              <a @click.prevent="refreshH('home')" class="turn_link">首页</a>
            </li>
            <li v-if="global.config[global.area_id]['isuser'] && global.config[global.area_id]['haslive']">
              <a @click.prevent="refreshH('live_schedule')" class="turn_link">大会直播</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/schedule',query:{sid:this.sid}}">日程安排</router-link> -->
              <!-- <a href="/schedule" class="turn_link">日程安排</a> -->
              <a @click.prevent="refreshH('schedule')" class="turn_link">日程安排</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/experts',query:{sid:this.sid}}">演讲嘉宾</router-link> -->
              <!-- <a href="/experts" class="turn_link">演讲嘉宾</a> -->
              <a @click.prevent="refreshH('experts')" class="turn_link">演讲嘉宾</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/about',query:{sid:this.sid}}">关于</router-link> -->
              <!-- <a href="/about" class="turn_link">关于</a> -->
              <a @click.prevent="refreshH('about')" class="turn_link">关于</a>
            </li>
            <li>
              <!-- <router-link class="turn_link" :to="{path:'/review',query:{sid:this.sid}}">往期回顾</router-link> -->
              <!-- <a href="/review" class="turn_link">往期回顾</a> -->
              <a @click.prevent="refreshH('review')" class="turn_link">往期回顾</a>
            </li>
            <li>
              <!-- <a v-if="sid==2690||sid==2691||sid=='2690'||sid=='2691'" @click.prevent="refreshH('collect')" class="turn_link">案例征集</a> -->
              <!-- <a v-if="sid==2690||sid==2691||sid=='2690'||sid=='2691'" :href="shref" target="_blank" class="turn_link">案例征集</a> -->
              <a v-if="sid==2690||sid==2691||sid=='2690'||sid=='2691'" @click.prevent="refreshH('col')" target="_blank" class="turn_link">案例征集</a>
            </li>
            <div class="mob">
              <div class="dibiao">
                <span class="glyphicon glyphicon-time"></span>
                <span class="wenz zd_time">{{meeting.time}}</span>
                <span class="wenz didian" style="float: right;" v-if="meeting.address.indexOf('直播')!=-1">{{meeting.address}}</span>
                <span class="wenz didian" style="float: right;" v-else>中国.{{global.config[sid].title}}</span>
                <span class="glyphicon glyphicon-map-marker" style="float: right;" ></span>
              </div>
              <div class="buy_btn">
                <a @click.prevent="refreshH('order')" class="turn_link_order wap_discount reallink">团队报名最低6折优惠！</a>
              </div>
            </div>
          </ul>
          <div class="buy_btn pc" v-if="global.area_id && global.config[global.area_id]">
            <!-- <router-link class="turn_link_order turn_link reallink" :to="{path:'/order',query:{sid:this.sid}}">立即购票</router-link> -->
            <!-- <a href="/order" class="turn_link_order turn_link reallink">立即购票</a> -->
            <a @click.prevent="refreshH('order')" class="turn_link" v-if="global.year.includes(thisYear)">立即购票</a>
            <a class="turn_link" v-else>已售罄</a>
          </div>
          <div class="buy_btn pc" v-else>
            <a class="turn_link">敬请期待</a>
          </div>
        </div>
      </div>
    </nav>
  </header>
  <!-- </div> -->
</template>

<script>
import $ from 'jquery'

/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
export default {
  name: 'Headall',
  data () {
    return {
      sid: '',
      shref: '',
      meeting: {time: '', address: ''},
      logined: false,
      token: '',
      thisYear: new Date().getFullYear()
    }
  },
  methods: {
    setInit (to_sid, from_sid) {
      // this.global.area_id = to_sid || this.$route.query.sid
      // this.global.year = (this.global.config[this.global.area_id] && this.global.config[this.global.area_id].year) || new Date().getFullYear()
      // this.global.year = this.global.year.trim()
      // this.$forceUpdate()
      // console.log(this.global.year, this.global.area_id)
      this.sid = this.global.area_id
      // this.shref = (this.sid==2690||this.sid=='2690')?'http://p.msup.cn/yEVX':'http://p.msup.cn/xtRU';
      if (!to_sid || to_sid !== from_sid) {
        this.getSchedule()
        this.global.config[this.global.area_id]['isuser']
          ? this.checkToken()
          : (
            localStorage.getItem('token') ? localStorage.removeItem('token') : '',
            localStorage.getItem('logins') ? localStorage.removeItem('logins') : ''
          )
      }
    },
    // toOrder: function(e){
    //   this.$router.push({path:'/order',name:'Order',query:{sid:e}});
    // },
    refreshH: function (r) {
      // this.$forceUpdate();
      // console.log("refresh ",r,"  ",this.sid,"  ",this.global.area_id,"  ");
      // if(this.sid!=this.global.area_id){
      //   this.sid = this.global.area_id;
      // }
      let lurl = window.location.search.substr(1).split('&')
      for (let i = 0; i < lurl.length; i++) {
        if (lurl[i].split('=')[0] === 'sid') {
          this.sid = lurl[i].split('=')[1]
          if (this.sid.toString() !== this.global.area_id.toString()) {
            this.global.area_id = this.sid
            this.global.year = (this.global.config[this.global.area_id] && this.global.config[this.global.area_id].year) || new Date().getFullYear()
            this.global.year = this.global.year.trim()
            this.global.address = this.global.config[this.global.area_id] && (this.global.config[this.global.area_id].address || (this.global.year + (this.global.config[this.global.area_id].jieshu || this.global.area_id)))
            this.global.address = this.global.address.trim()
          }
        };
      }
      let path = this.$route.path.split('/')[1]
      // console.log('path ',this.$route.path)
      if (r === 'col') {
        if (this.sid.toString() === '2691') {
          // console.log("2691");
          window.open('http://p.msup.cn/xtRU', '_blank')
        } else if (this.sid.toString() === '2690') {
          // console.log("2690");
          window.open('http://p.msup.cn/yEVX', '_blank')
        }
      } else if (path !== r) {
        this.$router.push({path: `/${r}`, query: {sid: this.sid}})
      }
      $('#bs-example-navbar-collapse-1').css('height', '1px')
      $('#bs-example-navbar-collapse-1').attr('aria-expanded', 'false')
      $('#bs-example-navbar-collapse-1').removeClass('in')
      $('#bs-example-navbar-collapse-2').css('height', '1px')
      $('#bs-example-navbar-collapse-2').attr('aria-expanded', 'false')
      $('#bs-example-navbar-collapse-2').removeClass('in')
      // setTimeout(() => {
      // }, 1000);
    },
    getSchedule () {
      if (this.global.isReallyNaN(parseInt(this.global.area_id))) {
        this.meeting.time = this.global.config[this.global.area_id].year + '.' + this.global.config[this.global.area_id].starttime + '~' + this.global.config[this.global.area_id].endtime
        this.meeting.address = this.global.config[this.global.area_id].title
        console.log(this.meeting.time, this.meeting.address)
      } else {
        let url_schedule = this.global.url.place + this.global.area_id
        this.$http
          .jsonp(url_schedule)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            if (data.status === '200') {
              this.meeting.time = this.global.formatTime(data.data.startTime, 'Y.M.D') + '~' + this.global.formatTime(data.data.endTime, 'D')
              this.meeting.address = data.data.address
              console.log(this.meeting.time, this.meeting.address)
            }
          })
      }
    },
    checkToken () {
      const _token = localStorage.getItem('token')
      // console.log(this.$route);
      // 如果链接携带了token则使用链接中的token，不存在则检测localStorage中是否有token
      if (this.$route.query.token) {
        this.token = this.$route.query.token
      } else if (_token && _token !== null) {
        this.token = _token
      } else {
        return false
      }
      if (this.$route.path !== '/login') {
        this.getUserName()
      }
    },
    getUserName () {
      let url = `${this.global.url.user.info}?token=${this.token}`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log("header- getUserInfo ", data);
          if (data.status === '200') {
            this.userName = data.data.name
            this.logined = true
          } else if (data.code === '1001' || data.status === '1011') {
            this.$message.closeAll()
            this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
            window.localStorage.removeItem('token')
            this.logined = false
            let _this = this
            setTimeout(() => {
              _this.login()
            }, 800)
          } else {
            console.log('获取用户信息失败')
          }
        })
    },
    login () {
      // window.localStorage.setItem("linkurl", window.location.href);
      window.localStorage.setItem('linkurl', window.location.pathname + window.location.search)
      this.$router.push({ path: '/login', query: {sid: this.sid} })
    },
    register () {
      // window.localStorage.setItem("linkurl", window.location.href);
      window.localStorage.setItem('linkurl', window.location.pathname + window.location.search)
      this.$router.push({ path: '/login', query: {sid: this.sid} })
    },
    quit () {
      window.localStorage.removeItem('logins')
      window.localStorage.removeItem('token')
      this.$nextTick(() => {
        this.logined = false
      })
      this.$router.push({
        path: `/home?sid=${this.global.area_id}${this.global.hashParam.qd ? `&qd=${this.global.hashParam.qd}` : ''}`
      })
      $('#bs-example-navbar-collapse-2').css('height', '1px')
      $('#bs-example-navbar-collapse-2').attr('aria-expanded', 'false')
      $('#bs-example-navbar-collapse-2').removeClass('in')
    },
    goUserCenter (id) {
      if (id || id === 0) {
        this.$router.push({
          path: `/user_center`,
          query: { sid: this.sid, selected: id }
        })
      } else {
        this.$router.push({
          path: `/user_center`,
          query: {sid: this.sid}
        })
      }
      $('#bs-example-navbar-collapse-2').css('height', '1px')
      $('#bs-example-navbar-collapse-2').attr('aria-expanded', 'false')
      $('#bs-example-navbar-collapse-2').removeClass('in')
    }
  },
  // created () {
  //   this.setInit()
  // },
  // mounted(){
  //   this.sid = this.global.area_id;
  //   if(this.$route.query.sid){
  //     this.sid = this.$route.query.sid;
  //   }
  //   // this.shref = (this.sid==2690||this.sid=='2690')?'http://p.msup.cn/yEVX':'http://p.msup.cn/xtRU';
  // },
  // computed:{
  //   cSid:function(){
  //     console.log("headWatch  ",this.sid);
  //     this.sid = this.global.area_id;
  //   }
  // },
  watch: {
    // sid(){
    //   // console.log("headWatch  ",this.sid);
    //   // this.sid
    //   // this.cSid();
    // }
    $route: {
      handler (to, from) {
        if (to && to.query) {
          // console.log(to.query.sid, this.global.area_id, this.global.config[to.query.sid].year)
          this.setInit(to.query.sid, from && from.query && from.query.sid)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 767px) {
  .navbar-default .navbar-nav>.open>a,
  .navbar-default .navbar-nav>.open>a:focus,
  .navbar-default .navbar-nav>.open>a:hover {
    background: #FFFFFF;
  }
  .header_top {
    /* max-width: 1300px; */
    margin: 0 auto;
    padding: 0px;
    background: #ffffff;
    border: none;
    img {
      margin-top: 12px;
      margin-right: 30px;
      padding-left: 10px;
    }
    .container-fluid {
      padding: 0;
      background: #FFFFFF;
    }
    ul li a {
      padding: 0;
      color: #575a5d!important;
      font-size: 18px;
      padding: 0 34px;
      height: 114px;
      line-height: 114px;
      font-weight: bold;
    }
    .buy_btn {
      transition: all 0.6s;
      float: right;
      width: 190px;
      height: 65px;
      line-height: 65px;
      background: #1889CB;
      border-radius: 4px;
      text-align: center;
      margin-top: 25px;
      margin-right: 10px;
      /* box-shadow: 3px 3px 3px #9ec4f6; */
      a {
        transition: all 0.6s;
        padding: 0;
        color: #ffffff!important;
        font-family: PingFang SC Semibold;
        font-size: 22px!important;
        height: auto!important;
        line-height: 66px;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .navbar-toggle {
      margin-top: 30px;
    }
  }
}
.header_top {
  ul li a:hover {
    color: #ffae0d!important;
    transition: all .6s;
  }
  a:hover {
    cursor: url("../../static/images/mouse2.png"), auto !important;
  }
  .buy_btn:hover {
    /* box-shadow: 0px 0px 10px #0458e3; */
    /* border-radius: 10px; */
    /* cursor: pointer; */
    box-shadow: 3px 3px 3px #9ec4f6;
    background: #56A0CC;
  }
  .buy_btn:hover, .buy_btn a:hover {
    cursor: url("../../static/images/mouse1.png"), auto !important;
  }
}
@media (min-width: 1020px) and (max-width:1440px) {
  .header_top {
    ul li a {
      padding: 0 12px;
    }
    img {
      padding-left: 10px;
    }
  }
}
@media (min-width:767px) and (max-width:850px) {
  .header_top {
    .buy_btn {
      width: 160px;
    }
  }
}
@media (min-width:767px) and (max-width:820px) {
  .header_top {
    .panel-heading {
      padding-right: 0;
    }
    img {
      margin-right: 0;
    }
  }
}
@media (min-width: 767px) and (max-width:1020px) {
  .header_top ul li a {
    padding: 0 12px;
  }
}
@media (min-width: 200px) and (max-width: 767px) {
  .navbar-fixed-top .navbar-collapse {
    max-height: 500px;
  }
  .navbar.header_top {
    margin-top: 0px;
    margin-bottom: 0!important;
    background: #FFFFFF;
    .navbar-header {
      border-bottom: none!important;
      img {
        margin-top: 4px;
        padding-left: 15px;
        height: 44px;
      }
    }
    .buy_btn {
      transition: all 0.6s;
      margin: 0 auto;
      width: 90%;
      height: 40px;
      line-height: 40px;
      background: #1889CB;
      border-radius: 4px;
      text-align: center;
      margin-top: 15px;
      margin-bottom: 25px;
      a {
        color: #FFFFFF;
        display: block;
        width: 100%;
      }
    }
    .dibiao {
      width: 85%;
      margin: 0 auto;
      margin-top: 24px;
    }
    ul li {
      width: 90%;
      margin: 0 auto;
      border-bottom: 1px solid #e6e6e6;
      a {
        padding-left: 5px;
        color: #000000!important;
        font-size: 18px;
      }
    }
  }
}
</style>

<style lang="scss">
.navbar-fixed-top {
  margin: 0 auto;
  background: #FFFFFF;
  .login-wrapper {
    width: 100%;
    height: 30px;
    background: #f3f3f3;
    .login {
      width: 100%;
      max-width: 1300px;
      margin: 0 auto;
      padding: 0 15px;
      display: flex;
      justify-content: space-between;
      // color: #ffffff;
      color: #666666;
      .login-right {
        margin-right: 10px;
        a {
          height: 30px;
          line-height: 30px;
          color: #666666;
          margin-left: 15px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
        }
        a:hover {
          color: #008aff;
          cursor: pointer;
        }
      }
      .login-left {
        display: flex;
        p {
          height: 30px;
          display: inline-block;
          line-height: 30px;
          font-size: 12px;
          font-weight: 500;
        }
        span, a {
          height: 30px;
          font-size: 12px;
          font-weight: 500;
          margin-left: 15px;
          color: #008aff;
          line-height: 30px;
          // cursor: pointer;
        }
        span.vip, a.vip {
          margin-left: 6px;
        }
        .register {
          margin-left: 0;
        }
      }
      .login-button {
        div {
          color: #008aff;
          display: inline;
        }
      }
    }
  }
  .container-fluid {
    max-width: 1300px;
    margin: 0 auto;
  }
  .panel, .panel-heading, .panel-default {
    background: transparent;
    border: none;
  }
}
@media (min-width:768px) {
  .navbar-fixed-top {
    .container-fluid {
      #bs-example-navbar-collapse-2 {
        display: none!important;
      }
    }
  }
}
@media (max-width:767px) {
  .navbar-fixed-top {
    .container-fluid {
      .navbar-header.isuser {
        width: 100%;
      }
    }
  }
}
@media (max-width:768px) {
  .navbar-fixed-top {
    .header_top {
      border-top: none;
      border-left: none;
      border-right: none;
    }
    .container-fluid {
      .panel-heading {
        background-color: transparent;
        padding: 0;
      }
      // .navbar-collapse.collapse.mob {
      //   display: block!important;
      // }
      .navbar-header.isuser::before, .navbar-header.isuser::after {
        content: none;
      }
      .navbar-header.isuser {
        // width: 100%;
        margin-left: 0;
        margin-right: 0;
        display: flex;
        justify-content: space-between;
        .navbar-toggle {
          float: none;
          margin-top: 8px;
          margin-right: 0;
        }
        .turn_link {
          display: flex;
          align-items: center;
        }
        img {
          margin-top: 0;
          padding-left: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Headall.vue